<template lang="html">
    <div class="d-flex">
        <div
            v-for="(suit, i) in suits"
            :key="i"
            class="single-card"
            :class="[
                {
                    'mr-4': i + 1 != suits.length,
                },
                getCardColor(suit),
            ]"
            :disabled="!isDrawn(suit)"
            :data-value="getCardValue('king')"
            :data-suit="getCardSuit(suit)"
        ></div>
    </div>
</template>

<script>
import cards from '@/mixins/cards';

export default {
    data() {
        return {
            suits: ['clubs', 'diamonds', 'spades', 'hearts'],
        };
    },
    mixins: [cards],
    computed: {
        kings() {
            const kings = this.$store.state.room.history
                .filter((history) => {
                    return (
                        history.type === 'card_revealed' &&
                        history.card.value === 'king'
                    );
                })
                .map((history) => history.card);
            return kings;
        },
    },
    watch: {
        kings: {
            handler(val) {
                if (val.length === 4) this.$bus.$emit('showEndgame');
            },
            immediate: true,
        },
    },
    methods: {
        isDrawn(suit) {
            if (this.kings.length > 0) {
                return this.kings.find((king) => king.suit === suit);
            }
        },
    },
};
</script>

<style lang="css"></style>
